<app-navigation-bar></app-navigation-bar>
<div id="mainwrapper" class="content">
    <div id="content" >
      <app-login-sign-up [@item] *ngIf="display" style="position: absolute; z-index: 1000;"></app-login-sign-up>
      <router-outlet></router-outlet>
  </div>  
</div>
  <!-- <div style="height: 40px;"></div> -->
  <app-footer-section></app-footer-section>